export default __webpack_public_path__ + "static/media/planes_icon.9db0fad1.jpg";